import { APP_COUNTRY, MAIN_SITE_HOMEPAGE } from 'config';

type MainSiteLinksMapping = {
  terms: string;
  accountClosureFaq: string;
  responsibleGaming: string;
  welcomeBonus: string;
  withdrawalsFaqUrl: string;
  topUpsFaq: string;
  helpCenter: string;
  bonusFreeBet: string;
};

const esLinks: MainSiteLinksMapping = {
  terms: `${MAIN_SITE_HOMEPAGE}terminos`,
  accountClosureFaq: `${MAIN_SITE_HOMEPAGE}ayuda/mi-cuenta`,
  responsibleGaming: `${MAIN_SITE_HOMEPAGE}juego-mas-seguro`,
  welcomeBonus: `${MAIN_SITE_HOMEPAGE}bonos/bono-de-bienvenida`,
  withdrawalsFaqUrl: `${MAIN_SITE_HOMEPAGE}ayuda/reintegros`,
  topUpsFaq: `${MAIN_SITE_HOMEPAGE}ayuda/depositos`,
  helpCenter: `${MAIN_SITE_HOMEPAGE}ayuda`,
  bonusFreeBet: `${MAIN_SITE_HOMEPAGE}apuestas-deportivas`,
};

const frLinks: MainSiteLinksMapping = {
  terms: `${MAIN_SITE_HOMEPAGE}modalites`,
  accountClosureFaq: `${MAIN_SITE_HOMEPAGE}aide/mon-compte`,
  responsibleGaming: `${MAIN_SITE_HOMEPAGE}jeu-responsable`,
  welcomeBonus: `${MAIN_SITE_HOMEPAGE}bonus/bonus-de-bienvenue`,
  withdrawalsFaqUrl: `${MAIN_SITE_HOMEPAGE}aide/retraits`,
  topUpsFaq: `${MAIN_SITE_HOMEPAGE}aide/depots`,
  helpCenter: `${MAIN_SITE_HOMEPAGE}aide`,
  bonusFreeBet: `${MAIN_SITE_HOMEPAGE}paris-sportifs`,
};

const ptLinks: MainSiteLinksMapping = {
  terms: `${MAIN_SITE_HOMEPAGE}termos`,
  accountClosureFaq: `${MAIN_SITE_HOMEPAGE}ajuda/conta`,
  responsibleGaming: `${MAIN_SITE_HOMEPAGE}jogo-responsavel`,
  welcomeBonus: `${MAIN_SITE_HOMEPAGE}bonus/bonus-de-boas-vindas`,
  withdrawalsFaqUrl: `${MAIN_SITE_HOMEPAGE}ajuda/levantamentos`,
  topUpsFaq: `${MAIN_SITE_HOMEPAGE}ajuda/depositos`,
  helpCenter: `${MAIN_SITE_HOMEPAGE}ajuda`,
  bonusFreeBet: `${MAIN_SITE_HOMEPAGE}`,
};

export const mainSiteLinks: MainSiteLinksMapping = {
  es: esLinks,
  fr: frLinks,
  pt: ptLinks,
}[APP_COUNTRY];
